import React, { useState, useEffect } from "react";
import { MessagesSquare, User, Bot, Zap } from "lucide-react";
import api from "@/lib/apiClient";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "");

export default function ConversationHistory({ business }) {
  const [sessions, setSessions] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/businesses/${business.id}/conversations`)
      .then((r) => setSessions(r.data))
      .catch(() => setSessions([]))
      .finally(() => setLoading(false));
  }, [business.id]);

  if (loading) return <p className="text-sm text-muted-foreground">Memuat riwayat percakapan...</p>;

  if (sessions.length === 0)
    return (
      <p className="text-sm text-muted-foreground" data-testid="conversations-empty">
        Belum ada percakapan untuk bisnis ini.
      </p>
    );

  return (
    <div className="space-y-2 max-w-3xl" data-testid="conversations-list">
      {sessions.map((s) => {
        const open = openId === s.session_id;
        const preview = s.messages.find((m) => m.role === "user")?.content || "—";
        return (
          <div key={s.session_id} data-testid="conversation-item" className="rounded-2xl border border-border bg-card overflow-hidden">
            <button onClick={() => setOpenId(open ? null : s.session_id)}
              className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-secondary/50 transition-colors">
              <MessagesSquare className="w-4 h-4 text-accent shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium truncate">{preview}</p>
                <p className="text-[11px] text-muted-foreground">{s.messages.length} pesan · {fmt(s.last_at)}</p>
              </div>
            </button>
            {open && (
              <div className="border-t border-border px-4 py-3 space-y-3 bg-muted/20">
                {s.messages.map((m, i) => (
                  <div key={i} className={`flex gap-2 ${m.role === "user" ? "" : "flex-row-reverse"}`}>
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${m.role === "user" ? "bg-secondary" : "bg-accent text-white"}`}>
                      {m.role === "user" ? <User className="w-3.5 h-3.5" /> : <Bot className="w-3.5 h-3.5" />}
                    </div>
                    <div className={`rounded-xl px-3 py-2 text-sm max-w-[80%] ${m.role === "user" ? "bg-secondary" : "bg-accent/10"}`}>
                      <p className="whitespace-pre-wrap">{m.content}</p>
                      {m.role === "assistant" && m.via === "static" && (
                        <span className="inline-flex items-center gap-1 text-[10px] text-emerald-600 mt-1">
                          <Zap className="w-3 h-3" /> Dijawab tanpa AI
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
